
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/invideo-vs-adobe-premiere-pro-agentic-vs-timeline",
      function () {
        return require("private-next-pages/blog/invideo-vs-adobe-premiere-pro-agentic-vs-timeline.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/invideo-vs-adobe-premiere-pro-agentic-vs-timeline"])
      });
    }
  